import React, { useEffect, useState, } from "react";
import AppRoutes from "../AppRoutes";



import { isNullOrEmpty } from "../config/ENV";
import Login from "../views/user/login";
import AuthRoutes from "./AuthRoutes";


const LoginRoutes = () => {

  return (
    <>
      {
        !isNullOrEmpty(window.localStorage.getItem("user")) ? (
          <AppRoutes />
        ) : (
          window.localStorage.getItem("account") == 'NewUser' ?
            <Login />
            :
            <AuthRoutes />

        )

      }
    </>
  );
};
export default LoginRoutes;